module.exports = __webpack_public_path__ + "static/media/logo1.2cab3327.png";